import { storyblokEditable } from '@storyblok/react';
import { motion } from 'framer-motion';
import { FC } from 'react';

import Container from '@/components/elements/Container';
import HeadingLayout from '@/components/elements/Heading';
import Prose from '@/components/elements/Prose';
import Section from '@/components/elements/Section';
import StandardText, {
  StandardTextSize,
} from '@/components/elements/StandardText';

export interface FeaturesIconLeftProps {
  blok: any;
  content: any;
}

const FeaturesIconLeft: FC<FeaturesIconLeftProps> = ({ blok }) => {
  const container = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.35,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 25 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        stiffness: 75,
        mass: 0.75,
        duration: 0.35,
      },
    },
  };

  return (
    <Section {...storyblokEditable(blok)}>
      <Container
        size={'wider'}
        className={`grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-16 lg:gap-24 xl:grid-cols-3`}
      >
        <div className="col-span-1">
          <StandardText blok={blok} size={StandardTextSize.MD} />
        </div>
        <motion.ol
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={container}
          className={`md:mt-14 col-span-1 grid list-outside list-none grid-cols-1 gap-12 ${
            blok?.columns === '1'
              ? `xl:col-span-2 xl:grid-cols-1`
              : `xl:col-span-2 xl:grid-cols-2`
          } self-start`}
        >
          {blok.features.map((v) => (
            <motion.li variants={item} key={v._uid} className="flex gap-4">
              {v.icon?.filename && (
                <div className="grid h-12 w-12 shrink-0 -translate-y-1/4 place-content-center items-center rounded-full bg-theme-lightgrey text-center text-4xl font-extralight text-white">
                  <img src={v.icon?.filename} alt="" />
                </div>
              )}
              <div className="space-y-2">
                <HeadingLayout size="2xs" weight="medium" className="mb-2">
                  {v.headline}
                </HeadingLayout>
                <Prose content={v.text} size="sm" />
              </div>
            </motion.li>
          ))}
        </motion.ol>
      </Container>
    </Section>
  );
};

export default FeaturesIconLeft;
